import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";

function Breadcrumbs({ link1, link2, link3, show, url1, url2, url3, bg, rtl }) {
  let className = "breadcrumbs_style";
  if (bg) {
    className += " white";
  }
  if (rtl) {
    className += " rtl-style";
  }

  return (
    <section className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12}>
            <ul className="breadcrumb">
              <li>
                <Link to={url1}>{link1}</Link>
              </li>
              <li>
                <Link to={url2}>{link2}</Link>
              </li>
              {show === "yes" ? null : (
                <li>
                  <Link to={url3}>{link3}</Link>
                </li>
              )}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Breadcrumbs;
